import { authenticatedApiFetch } from '../utils/utils'


export const createQuestionInterrogationInstanceService = async (question) => {
    const res = await authenticatedApiFetch(`/questions-interrogation-instances/`, { method: 'POST', body: JSON.stringify(question) })
        .then(response => response.json())
        .catch(error => console.error(error))
    return res
}
